import { useSession } from "@/src/contexts/AuthContext";
import { useApiClient } from "@/src/hooks/useApiClient";
import { useQueryErrorToast } from "@/src/hooks/useQueryErrorToast";
import { useTranslations } from "@/src/i18n/i18n";

/**
 * Revalide la session auprès du serveur.
 *
 * Modèle de hook de **query** à reprendre : on expose une API lisible
 * (`{ account, isLoading, refetch }`), jamais l'objet React Query brut.
 *
 * `enabled` sur la présence du jeton : sans lui, la requête partirait sans
 * `Authorization` et le 401 renvoyé ne dirait rien de la session — cf.
 * `isTokenRejection`.
 */
export function useWhoami() {
  const { session } = useSession();
  const $api = useApiClient();
  const t = useTranslations("dashboard");

  const { data, error, isError, isLoading, refetch } = $api.useQuery(
    "get",
    "/api/v1/auth",
    {},
    { enabled: Boolean(session?.token) },
  );

  useQueryErrorToast(isError, t("session-error"), error);

  return {
    account: data?.data,
    isLoading,
    isError,
    refetch,
  };
}
